const modalsTypes = {
    TOGGLE_CHANGE_PASS : 'TOGGLE_CHANGE_PASS',
    TOGGLE_SETTING_MODAL : 'TOGGLE_SETTING_MODAL',
    TOGGLE_ICONS : 'TOGGLE_ICONS',
    TOGGLE_SIGN_MODAL: "TOGGLE_SIGN_MODAL",
    TOGGLE_STATUS_MODAL: "TOGGLE_STATUS_MODAL",
    TOGGLE_REPORTS_MODAL:"TOGGLE_REPORTS_MODAL",
    TOGGLE_DRAWER: "TOGGLE_DRAWER",
    TOGGLE_PAYMENT: "TOGGLE_PAYMENT",
    TOGGLE_SUCCESS: "TOGGLE_SUCCESS",
    TOGGLE_INIT_MODAL: "TOGGLE_INIT_MODAL"
}

export default modalsTypes;